export default __webpack_public_path__ + "static/media/event-isc-brasil.5ac0b8ae.jpg";